module.exports = __webpack_public_path__ + "account/img/101.1854f319.png";